<template>
  <div class="choice-vote">
    <choice-vote-content :items="items" />
    <div class="mt-4" v-if="showMoreRank">
      <van-button size="small" block plain type="primary" @click="onShowMoreRank">查看更多排名</van-button>
    </div>
  </div>
</template>

<script>
import { questionType } from 'dygc'
import choice from './choice'
import CustomProgress from './CustomProgress.vue'
import { createPopup } from '../assets/js/factory'
import ChoiceMoreRank from './ChoiceMoreRank.vue'
import ChoiceVoteContent from './ChoiceVoteContent.vue'

export default {
  name: 'ChoiceVote',
  components: { ChoiceVoteContent, CustomProgress },
  mixins: [choice],
  type: [questionType.SINGLE_CHOICE, questionType.MULTIPLE_CHOICE, questionType.SINGLE_SELECT, questionType.MULTIPLE_SELECT],
  computed: {
    showMoreRank() {
      return this.items.length > 5
    }
  },
  methods: {
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        items: this.items,
        question:this.question
      })
    }
  }
}
</script>
